



import { defineComponent, computed, PropType } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import getComponent from "./views";

export default defineComponent({
  name: "StreamMessage",
  props: {
    message: { type: Object as () => Message, required: true },
    referrersMap: { type: Object as PropType<Record<string, UserPublicData>> },
  },
  setup(props) {
    const messageView = computed(() => getComponent(props.message));

    return { messageView, getComponent };
  },
});
